import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { UnitsData } from './units.entity';
import { UnitsDataService } from './units-service';
import { UnitsDataController } from './units-controller';
import { UnitsDataRepository } from './units-repo';
import { UnitsDataAdapter } from './units-adapter';
import { ApplicationExceptionHandler } from '@project-management-system/backend-utils';


@Module({
    imports: [TypeOrmModule.forFeature([UnitsData])],
    controllers: [UnitsDataController],
    providers: [UnitsDataService, UnitsDataRepository, UnitsDataAdapter, ApplicationExceptionHandler],
})
export class UnitsDataModule {}
